import * as Sentry from '@sentry/vue';
import { createApp } from 'vue';
import { env } from '@/constants/env';
import type { Integration } from '@sentry/core';

const dsn = 'https://2ea6f2a6d3351e7a7bf5efe28dfb1937@sentry.notesauditor.ai/5';

interface CommonSentryOptions {
  integrations: Integration[];
  defaultIntegrations: false;
}

// Reduced integration set for better performance by excluding browser tracing
const commonSentryConfig: CommonSentryOptions = {
  integrations: [
    Sentry.globalHandlersIntegration(),
    Sentry.functionToStringIntegration(),
    Sentry.inboundFiltersIntegration(),
    Sentry.linkedErrorsIntegration(),
    Sentry.dedupeIntegration(),
  ],
  defaultIntegrations: false,
};

const configs = [
  {
    sources: ['PRODUCTION', 'ANALYSTS'],
    config: {
      environment: 'PRODUCTION',
      tracesSampleRate: 0, // Disabled performance monitoring for better performance
    },
  },
  {
    sources: ['STAGING', 'BDOTEST'],
    config: {
      environment: 'STAGING',
      tracesSampleRate: 0, // Disabled performance monitoring for better performance
    },
  },
  {
    sources: ['DEVELOPMENT'],
    config: {
      environment: 'DEVELOPMENT',
      tracesSampleRate: 0, // Disabled performance monitoring for better performance
    },
  },
];

export function initSentry(app: ReturnType<typeof createApp>, sentryEnv?: string) {
  const environment = sentryEnv?.trim() || 'DEVELOPMENT';

  const targetConfig = configs.find(config => config.sources.includes(environment.toUpperCase()));

  if (targetConfig) {
    Sentry.init({
      app,
      dsn,
      release: env.VITE_ENV_RELEASE_VERSION ? env.VITE_ENV_RELEASE_VERSION.slice(1, -1) : undefined,
      ...commonSentryConfig,
      ...targetConfig.config,
      tracesSampleRate: 0, // Explicitly disable traces for performance optimization
    });
  } else {
    // Fallback to development config when environment doesn't match any predefined sources
    Sentry.init({
      app,
      dsn,
      environment: 'DEVELOPMENT',
      release: env.VITE_ENV_RELEASE_VERSION ? env.VITE_ENV_RELEASE_VERSION.slice(1, -1) : undefined,
      ...commonSentryConfig,
      tracesSampleRate: 0, // Explicitly disable traces for performance optimization
    });
  }
}
